<ion-grid class="transactions-page">
  <ion-row class="card-row">
    <!-- <ion-col size="12" size-sm="6" size-md="3" >
      
    </ion-col> -->

    <ion-card class="summary-card" *ngFor="let card of summaryCards">
      <div class="card-content">
        <div class="text-section">
          <p class="label">{{ card.label }}</p>
          <h2 class="value">{{ card.value }}</h2>
        </div>
        <div class="icon-section" [ngStyle]="{ 'background-color': card.bgColor }">
          <!-- <ion-icon [name]="card.icon"></ion-icon> -->
          <ion-img [src]="card.imgLink" alt="{{ card.label }}" class="icon-image"></ion-img>
        </div>
      </div>
    </ion-card>
  </ion-row>

  <ion-row class="table-row">
    <div class="metric-card recentTransactionsWrapper">
      <div class="tableHeader">
        <div class="content">
          <h3 class="title">
            Recent Transactions
          </h3>
          <p class="subTitle">
            Showing {{ selectedMonthYear ? (selectedMonthYear | date:'MMM yyyy') : 'All' }} transactions for account
            {{selectedAccount}}
          </p>
        </div>
        <!-- <div class="balanceWrapper">
          <div class="currentBalance">
            <p class="label">Current Balance:</p>
            <p class="amount">$65,000</p>
          </div>
          <div class="availableBalance">
            <p class="label">Available Balance:</p>
            <p class="amount">$64,300.41</p>
          </div>
        </div> -->

        <div class="actionHeader">
          <div class="actionItem monthYearPicker ">

            <ng-container *ngIf="isMobile; else webView">

              <ion-item>
                <!-- <ion-label position="stacked">Month & Year</ion-label> -->
                <ion-datetime-button datetime="datetime">
                  <!-- <ion-icon name="calendar-outline"></ion-icon> -->
                </ion-datetime-button>

              </ion-item>

              <ion-modal [keepContentsMounted]="true" class="monthYearPickerModal">
                <ng-template>
                  <ion-datetime id="datetime" presentation="month-year" [value]="tempSelectedDate"
                    [showDefaultButtons]="true" confirmText="OK" cancelText="Cancel"
                    (ionChange)="handleDateChange($event)"></ion-datetime>
                </ng-template>
              </ion-modal>

              <!-- Show selected month -->
              <!-- <ion-item lines="none">
                <ion-label>
                  {{ selectedMonthYear ? (selectedMonthYear | date:'MMM yyyy') : 'No date selected' }}
                </ion-label>
              </ion-item> -->

            </ng-container>
            <ng-template #webView>
              <!-- Web UI -->
              <mat-form-field appearance="outline" class="general-input">
                <!-- <mat-label>Month & Year</mat-label> -->
                <input matInput [matDatepicker]="picker" [(ngModel)]="selectedMonthYear" readonly>
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker startView="multi-year" (monthSelected)="chosenMonthHandler($event, picker)"
                  panelClass="month-picker">
                </mat-datepicker>
              </mat-form-field>
            </ng-template>
          </div>

          <div class="actionItem accountsSelector ">
            <mat-form-field *ngIf="showAccountDropdown" appearance="fill" class="w-100">
              <mat-label>Account</mat-label>
              <mat-select [(value)]="selectedAccount" (selectionChange)="onAccountChange($event)">
                <mat-option *ngFor="let account of accountsList"
                  [value]="account.account_name +' - '+account.acct_last_4">
                  {{(account.account_name.length>12 ? (account.account_name | slice:0:12) +'...': account.account_name)
                  +' - '+account.acct_last_4 }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <div *ngIf="!showAccountDropdown && accountsList.length === 1" class="single-account-display">
              <label class="account-label">Account</label>
              <div class="account-value">
                {{(accountsList[0].account_name.length>12 ? (accountsList[0].account_name | slice:0:12) +'...':
                accountsList[0].account_name)
                +' - '+accountsList[0].acct_last_4 }}
              </div>
            </div>
          </div>
          <!-- <app-primary-button [iconOrder]="'right'" [ionIconName]="'arrow-forward-outline'" [label]="'Add Transaction'"
            customClass="primaryBtn" (click)="prevPage()">
          </app-primary-button> -->
        </div>
      </div>

      <ng-container *ngIf="isMobile; else isWebView">
        <div class="w-100 mobileTableDataWrapper">
          <div class="tableWrapper">
            <ion-list>
              <ion-item *ngFor="let row of [0,1,2,3,4,5,6,7,8,9]" class="transaction-item"
                (click)="showTransactionDetails($event)">
                <ion-label>
                  <ion-grid>
                    <ion-row class="">
                      <ion-col size="6" class="ion-no-padding">
                        <h3 class="tableTitle">Simplement du faux text..</h3>
                      </ion-col>
                      <ion-col size="6" class="ion-no-padding">
                        <p class="tableAmount">$1,200.00</p>
                      </ion-col>
                      <ion-col size="12" class="ion-no-padding">
                        <p class="tableDate">May 15, 2025</p>
                      </ion-col>
                    </ion-row>
                  </ion-grid>
                </ion-label>
              </ion-item>
            </ion-list>
          </div>
        </div>
      </ng-container>

      <ng-template #isWebView>
        <div class="w-100 tableDataWrapper">
          <div class="tableWrapper">
            <!-- <mat-form-field>
                        <mat-label>Filter</mat-label>
                        <input matInput (keyup)="applyFilter($event)" placeholder="Ex. Mia" #input>
                      </mat-form-field> -->
            <table mat-table [dataSource]="dataSource" matSort class="w-100">

              <!-- Date Column -->
              <ng-container matColumnDef="date">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Date </th>
                <td mat-cell *matCellDef="let row"> {{row.date | date:'MMM d, y' }} </td>
              </ng-container>

              <!-- Merchant Column -->
              <!-- <ng-container matColumnDef="merchantName">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Merchant</th>
              <td mat-cell *matCellDef="let row"> {{row.merchantName}}</td>
            </ng-container> -->

              <!-- Primary Category Column -->
              <ng-container matColumnDef="primaryCategory">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Category </th>
                <td mat-cell *matCellDef="let row"> {{row.primaryCategory}} </td>
              </ng-container>

              <!-- Category Detail Column -->
              <ng-container matColumnDef="categoryDetail">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Description </th>
                <td mat-cell *matCellDef="let row"> {{row.categoryDetail}} </td>
              </ng-container>

              <!-- Status Detail Column -->
              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Status </th>
                <td mat-cell *matCellDef="let row"> {{row.status}} </td>
              </ng-container>

              <!-- Tax Column -->
              <ng-container matColumnDef="taxPercent">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Tax Percent </th>
                <td mat-cell *matCellDef="let row"> {{row.taxPercent}}% </td>
              </ng-container>

              <!-- Amount Column -->
              <ng-container matColumnDef="amount">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Amount</th>
                <td mat-cell *matCellDef="let row"> {{row.amount | currency:'USD':'symbol':'1.2-2'}} </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedTransactionColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedTransactionColumns;"></tr>

              <!-- Row shown when there is no data. -->
              <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell no-data-cell" [attr.colspan]="displayedTransactionColumns.length">
                  <!-- <div class="no-data-container">
                  <ion-icon name="document-outline" class="no-data-icon"></ion-icon>
                  <h3 class="no-data-title">No Transactions Found</h3>
                  <p class="no-data-message">
                    {{ selectedMonthYear ? `No transactions found for ` + (selectedMonthYear | date:'MMM yyyy') : `No
                    transactions available` }}
                  </p>
                </div> -->

                  <app-no-data title="No Transactions Found" message="{{ selectedMonthYear ? `No transactions found for `
                  + (selectedMonthYear | date:'MMM yyyy') : `No transactions available` }}"></app-no-data>
                </td>
              </tr>
            </table>
          </div>
          <!-- <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]" aria-label="Select page of Transactions"></mat-paginator> -->
        </div>
        <!-- <a href="#" class="primaryLink d-block">See Comparision
        <ion-icon name="arrow-forward-outline"></ion-icon>
      </a> -->
        <div class="pagination-container" *ngIf="totalEntries > 0">
          <div class="pagination-info">
            Showing {{ displayedTransactions.length }} of {{ totalEntries }} entries
          </div>
          <app-primary-button *ngIf="hasMoreData" [iconOrder]="'right'" [ionIconName]="'reload-outline'"
            [label]="'Load More'" customClass="primaryBtn" (click)="loadMoreTransactions()">
          </app-primary-button>
          <!-- <div class="pagination-controls">          
          <div class="primaryBtnWrapper">
            <app-primary-button [iconOrder]="'left'" [ionIconName]="'chevron-back-outline'" [label]="'Previous'"
              [disabled]="currentPage === 1" customClass="nav-button" (click)="prevPage()">
            </app-primary-button>
          </div>
          <ion-button *ngFor="let page of visiblePages" class="page-button" [class.active]="page === currentPage"
            (click)="goToPage(page)">
            {{ page }}
          </ion-button>         
          <div class="primaryBtnWrapper">
            <app-primary-button [iconOrder]="'right'" [ionIconName]="'chevron-forward-outline'" [label]="'Next'"
              [disabled]="currentPage === totalPages" customClass="nav-button" (click)="nextPage()">
            </app-primary-button>
          </div>
        </div> -->


        </div>
      </ng-template>
    </div>
  </ion-row>
</ion-grid>